// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.BookingPanel_booking__ssfyt {
  width: 100%;
  max-width: 370px;
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.075);
  border-radius: 22px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  padding: 24px 18px 16px;
  font-family: "Sora", sans-serif;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.BookingPanel_booking__ssfyt:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);
}
.BookingPanel_booking__head__H4HO8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.BookingPanel_booking__title__K6ruR {
  margin: 0 0 10px;
  text-align: center;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.025em;
  color: #13231D;
}
.BookingPanel_booking__request-title__BpJg5 {
  white-space: nowrap;
  letter-spacing: -0.035em;
}
.BookingPanel_booking__request-intro__jc8iu {
  max-width: 320px;
  margin: 0 auto 14px;
  text-align: center;
  font-size: 12px;
  line-height: 1.45;
  color: #5A6A63;
}
.BookingPanel_booking__legend__QGZul {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  margin: 0 0 14px;
  font-size: 10px;
  color: #5f6d67;
  font-weight: 700;
}
.BookingPanel_booking__dot__WLeTk {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  border: 2px solid #82B194;
  display: inline-block;
  margin-right: 6px;
  vertical-align: -2px;
  background: white;
}
.BookingPanel_booking__dot--selected__4v9BJ {
  background: #82B194;
}
.BookingPanel_booking__today-mark__1Avbe {
  display: inline-block;
  margin-right: 4px;
  color: #D6A640;
  font-weight: 900;
  font-size: 11px;
  vertical-align: middle;
  line-height: 1;
  background: transparent;
  box-shadow: none;
}
.BookingPanel_booking__calendar-card__kJJyZ {
  padding: 6px 2px 10px;
}
.BookingPanel_booking__calendar-days-frame__VYP1T {
  padding: 8px 6px 7px;
  border: 1px solid rgba(12, 36, 28, 0.075);
  border-radius: 16px;
}
.BookingPanel_booking__field-wrapper__JKgBr {
  margin-top: 10px;
}
.BookingPanel_booking__field-inner__X42e- {
  width: 100%;
}
.BookingPanel_booking__select-container__U44VT {
  background: #F8F6F2;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 18px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.02);
  display: flex;
  align-items: center;
  padding-right: 14px;
  transition: border-color 0.2s;
}
.BookingPanel_booking__select-container__U44VT:hover {
  border-color: rgba(130, 177, 148, 0.5);
}
.BookingPanel_booking__select-container__U44VT .MuiTextField-root .BookingPanel_MuiOutlinedInput-notchedOutline__FRhsC {
  border: none;
}
.BookingPanel_booking__select-container__U44VT .MuiTextField-root .BookingPanel_MuiInputBase-root__EclzM {
  height: 48px;
}
.BookingPanel_booking__select-container__U44VT .MuiTextField-root .BookingPanel_MuiSelect-select__BCOS5 {
  padding-left: 14px;
  font-size: 13px;
  font-weight: 700;
  color: #13231D;
}
.BookingPanel_booking__field-icon__DmP8F {
  width: 20px;
  height: 20px;
  stroke: #6f7d75;
  stroke-width: 1.9px;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  margin-right: 8px;
}
.BookingPanel_booking__type-picker__zBrNt {
  margin: 0 0 12px;
}
.BookingPanel_booking__mini-label__h9BZM {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: #6E897C;
}
.BookingPanel_booking__secondary-group__sZ1GC {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 8px;
}
.BookingPanel_booking__secondary__lYNKQ {
  min-height: 40px;
  padding: 0 11px;
  border: 1px solid rgba(130, 177, 148, 0.58);
  border-radius: 15px;
  background: transparent;
  color: #32453B;
  font-family: inherit;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}
.BookingPanel_booking__secondary__lYNKQ:hover {
  background: rgba(130, 177, 148, 0.08);
}
.BookingPanel_booking__secondary--active__jLVSV {
  background: rgba(130, 177, 148, 0.16);
  border-color: #82B194;
}
.BookingPanel_booking__type-helper__4CC0n {
  margin: 8px 2px 0;
  font-size: 11px;
  line-height: 1.5;
  color: #5A6A63;
}
.BookingPanel_booking__split-card__IH\\+77 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
  background: transparent;
  border: 0;
  border-radius: 0;
  overflow: visible;
}
.BookingPanel_booking__split-card__IH\\+77 button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 11px;
  border: 1px solid rgba(130, 177, 148, 0.58);
  border-radius: 15px;
  background: transparent;
  color: #32453B;
  font-size: 11px;
  line-height: 1.25;
  font-weight: 800;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.BookingPanel_booking__split-card__IH\\+77 button img {
  width: 21px;
  height: 21px;
  object-fit: contain;
  opacity: 0.88;
  flex: 0 0 auto;
}
.BookingPanel_booking__split-card__IH\\+77 button.BookingPanel_is-active__n2PCn {
  background: rgba(130, 177, 148, 0.16);
  border-color: #82B194;
  color: #32453B;
  box-shadow: none;
}
.BookingPanel_booking__split-card__IH\\+77 button:hover:not(.BookingPanel_is-active__n2PCn) {
  background: rgba(130, 177, 148, 0.12);
}
.BookingPanel_booking__price-row__DCR7a {
  min-height: 46px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  padding: 6px 2px 5px 10px;
}
.BookingPanel_booking__price-copy__pJY21 {
  display: flex;
  align-items: baseline;
  gap: 9px;
  min-width: 0;
}
.BookingPanel_booking__price-summary__Gd3u2 {
  font-size: 12px;
  white-space: nowrap;
}
.BookingPanel_booking__price-duration__3i3WL {
  font-size: 10.5px;
  font-weight: 700;
  color: rgba(19, 35, 29, 0.68);
  white-space: nowrap;
}
.BookingPanel_booking__price__UEDao {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
}
.BookingPanel_booking__price-amount__0iV1d {
  font-size: 23px;
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1;
}
.BookingPanel_booking__cta__Z3BIy {
  margin-top: 10px;
  width: 100%;
  min-height: 46px;
  border-radius: 15px;
  border: 0;
  background: #82B194;
  color: white;
  font-family: inherit;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s;
}
.BookingPanel_booking__cta__Z3BIy:hover:not(:disabled) {
  background: rgb(114.2980295567, 167.2019704433, 134.5591133005);
  transform: translateY(-1px);
}
.BookingPanel_booking__cta__Z3BIy:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.BookingPanel_booking__secondary-cta__-ib-n {
  width: 100%;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 16px;
  border: 1px solid rgba(130, 177, 148, 0.58);
  border-radius: 15px;
  background: transparent;
  color: #32453B;
  font-family: inherit;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.18s ease;
}
.BookingPanel_booking__secondary-cta__-ib-n svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.BookingPanel_booking__secondary-cta__-ib-n:hover {
  background: rgba(130, 177, 148, 0.1);
}
.BookingPanel_booking__validation-summary__UUeUm {
  margin: 14px 0 0;
  padding: 9px 10px;
  border: 1px solid rgba(173, 77, 67, 0.24);
  border-radius: 12px;
  background: #FAEEEB;
  color: #82483F;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.45;
}

@keyframes BookingPanel_shake__fAhsu {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
}
.BookingPanel_shake__fAhsu {
  animation: BookingPanel_shake__fAhsu 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.BookingPanel_calendar__jNEUM {
  width: 100%;
  padding: 2px 3px 3px;
}

.BookingPanel_calendar-top__FHYxC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  min-height: 30px;
}

.BookingPanel_month__ws0VY {
  margin-left: 10px;
  font-size: 12px;
  font-weight: 800;
  text-transform: capitalize;
}

.BookingPanel_navs__3DBuV {
  display: flex;
}

.BookingPanel_nav-btn__Xv8IT {
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #42524B;
  font: inherit;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.BookingPanel_nav-btn__Xv8IT:hover {
  background: rgba(0, 0, 0, 0.05);
}

.BookingPanel_calendar-frame__T0tb- {
  padding: 7px 6px 6px;
  border: 1px solid rgba(12, 36, 28, 0.07);
  border-radius: 16px;
}

.BookingPanel_dow__F-ggq, .BookingPanel_days__Z6nCZ {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  text-align: center;
}

.BookingPanel_dow__F-ggq {
  padding-bottom: 5px;
  margin-bottom: 6px;
  border-bottom: 1px solid rgba(12, 36, 28, 0.06);
}

.BookingPanel_dow__F-ggq span {
  font-size: 8px;
  font-weight: 800;
}

.BookingPanel_days__Z6nCZ {
  row-gap: 2px;
}

.BookingPanel_slot__jwwND {
  height: 28px;
  display: grid;
  place-items: center;
}

.BookingPanel_day__2ADRM {
  position: relative;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #5B6862;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.BookingPanel_day--out__45rKU {
  color: #B0B7B3;
}

.BookingPanel_day--available__dcoLs {
  box-shadow: inset 0 0 0 1.3px #82B194;
  background: #EEF5F0;
  color: #32483E;
  cursor: pointer;
}

.BookingPanel_day--requestable__J0kml {
  color: #4C5D55;
  cursor: pointer;
}

.BookingPanel_day--booked__P1LFM::after {
  content: "";
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #82B194;
}

.BookingPanel_day--today__fCAEC {
  color: #D6A640;
  font-weight: 900;
}

.BookingPanel_day--selected__IhC\\+c {
  background: var(--bw-primary, #82B194) !important;
  color: #fff !important;
  font-weight: 900 !important;
}

.BookingPanel_legend__BtxQE {
  display: flex;
  justify-content: center;
  gap: 14px;
  align-items: center;
  margin: -4px 2px 10px;
  font-size: 9px;
  color: rgba(19, 35, 29, 0.66);
  font-weight: 700;
}

.BookingPanel_lg__eh3ax {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.BookingPanel_ring__wGi4J {
  width: 9px;
  height: 9px;
  border: 1.3px solid #82B194;
  border-radius: 50%;
  background: #EEF5F0;
}

.BookingPanel_dot-green__ViCDd {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #82B194;
}

.BookingPanel_period-picker__5qq4P {
  position: relative;
  margin-top: 0;
}

.BookingPanel_period-trigger__irnTO {
  width: 100%;
  min-height: 42px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(12, 36, 28, 0.1);
  border-radius: 16px;
  background: var(--bw-surface, #F7F5F1);
  color: rgba(19, 35, 29, 0.72);
  font-family: inherit;
  font-size: 11px;
  font-weight: 650;
  cursor: pointer;
}

.BookingPanel_period-trigger__irnTO[aria-expanded=true] {
  border-color: rgba(130, 177, 148, 0.72);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.14);
}

.BookingPanel_period-trigger__irnTO:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.BookingPanel_period-menu__pbut8 {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 6;
  display: none;
  padding: 6px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 16px;
  background: var(--bw-surface, #F7F5F1);
  box-shadow: 0 14px 28px rgba(19, 35, 29, 0.1);
  max-height: 200px;
  overflow-y: auto;
}

.BookingPanel_period-menu__pbut8.BookingPanel_is-open__HGtxg {
  display: block;
}

.BookingPanel_period-option__qPxl8 {
  width: 100%;
  min-height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 11px;
  background: transparent;
  color: #13231D;
  font-family: inherit;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.BookingPanel_period-option__qPxl8.BookingPanel_is-active__n2PCn, .BookingPanel_period-option__qPxl8:hover {
  background: rgba(130, 177, 148, 0.16);
  color: #345443;
}

.BookingPanel_passive-compact-note__GpgO1 {
  margin: 18px 2px 8px;
  color: rgba(19, 35, 29, 0.56);
  font-size: 10.5px;
  line-height: 1.5;
  text-align: center;
}

.BookingPanel_availability-dev-code-link__02Ka2 {
  margin: 0 2px;
  display: flex;
  justify-content: flex-end;
}
.BookingPanel_availability-dev-code-link__02Ka2 a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #5E806C;
  font-size: 10.5px;
  font-weight: 800;
  text-decoration: none;
}
.BookingPanel_availability-dev-code-link__02Ka2 a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ProfessionalDetail/BookingPanel.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AANA;EACI,WAAA;EACA,gBAAA;EACA,mBDMmB;ECLnB,yCAAA;EACA,mBAAA;EACA,2CAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EAEA,qDAAA;AAQJ;AANI;EACI,2BAAA;EACA,8CAAA;AAQR;AALI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAOR;AAJI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,cDnBe;ACyBvB;AAHI;EACI,mBAAA;EACA,wBAAA;AAKR;AAFI;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIR;AADI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAGR;AAAI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AAER;AAAQ;EACI,mBDvEW;ACyEvB;AAEI;EACI,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;AAAR;AAGI;EACI,qBAAA;AADR;AAII;EACI,oBAAA;EACA,yCAAA;EACA,mBAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;EACI,WAAA;AAJR;AAOI;EACI,mBDjGe;ECkGf,wCAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AALR;AAOQ;EACI,sCAAA;AALZ;AASY;EACI,YAAA;AAPhB;AAUY;EACI,YAAA;AARhB;AAWY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDvHO;AC8GvB;AAcI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AAZR;AAiBI;EACI,gBAAA;AAfR;AAkBI;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAhBR;AAmBI;EACI,aAAA;EACA,gDAAA;EACA,SAAA;EACA,eAAA;AAjBR;AAoBI;EACI,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oDAAA;AAlBR;AAoBQ;EACI,qCAAA;AAlBZ;AAqBQ;EACI,qCAAA;EACA,qBD5LW;ACyKvB;AAuBI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AArBR;AAwBI;EACI,aAAA;EACA,gDAAA;EACA,QAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AAtBR;AAwBQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,4EAAA;AAtBZ;AAwBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAtBhB;AAyBY;EACI,qCAAA;EACA,qBD7OO;EC8OP,cAAA;EACA,gBAAA;AAvBhB;AA0BY;EACI,qCAAA;AAxBhB;AA6BI;EACI,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AA3BR;AA8BI;EACI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AA5BR;AA+BI;EACI,eAAA;EACA,mBAAA;AA7BR;AAgCI;EACI,iBAAA;EACA,gBAAA;EACA,6BAvRG;EAwRH,mBAAA;AA9BR;AAiCI;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;AA/BR;AAkCI;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAhCR;AAmCI;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBDxSe;ECySf,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAjCR;AAmCQ;EACI,+DAAA;EACA,2BAAA;AAjCZ;AAoCQ;EACI,mBAAA;EACA,YAAA;AAlCZ;AAsCI;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AApCR;AAsCQ;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AApCZ;AAuCQ;EACI,oCAAA;AArCZ;AAyCI;EACI,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAvCR;;AA6CA;EAEI;IAEI,wBAAA;EA5CN;EA+CE;IACI,2BAAA;EA7CN;EAgDE;IACI,0BAAA;EA9CN;EAiDE;IACI,2BAAA;EA/CN;AACF;AAkDA;EACI,mFAAA;AAhDJ;;AAkDA;EAAU,WAAA;EAAW,oBAAA;AA7CrB;;AA8CA;EAAc,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,kBAAA;EAAkB,gBAAA;AAtC9F;;AAuCA;EAAO,iBAAA;EAAiB,eAAA;EAAe,gBAAA;EAAgB,0BAAA;AAhCvD;;AAiCA;EAAM,aAAA;AA7BN;;AA8BA;EAAS,WAAA;EAAW,YAAA;EAAY,SAAA;EAAS,kBAAA;EAAkB,uBAAA;EAAuB,cAAA;EAAc,aAAA;EAAa,eAAA;EAAe,eAAA;EAAe,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,UAAA;AAdlM;;AAeA;EAAe,+BAAA;AAXf;;AAYA;EAAgB,oBAAA;EAAoB,wCAAA;EAAoC,mBAAA;AANxE;;AAOA;EAAW,aAAA;EAAa,gDAAA;EAA8C,kBAAA;AADtE;;AAEA;EAAK,mBAAA;EAAmB,kBAAA;EAAkB,+CAAA;AAI1C;;AAHA;EAAU,cAAA;EAAc,gBAAA;AAQxB;;AAPA;EAAM,YAAA;AAWN;;AAVA;EAAM,YAAA;EAAY,aAAA;EAAa,mBAAA;AAgB/B;;AAfA;EAAK,kBAAA;EAAkB,WAAA;EAAW,YAAA;EAAY,SAAA;EAAS,kBAAA;EAAkB,uBAAA;EAAuB,cAAA;EAAc,aAAA;EAAa,eAAA;EAAe,gBAAA;EAAgB,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,UAAA;AAgCjN;;AA/BA;EAAU,cAAA;AAmCV;;AAlCA;EAAgB,qCAAA;EAAyC,mBAAA;EAAmB,cAAA;EAAc,eAAA;AAyC1F;;AAxCA;EAAkB,cAAA;EAAc,eAAA;AA6ChC;;AA5CA;EAAoB,WAAA;EAAW,kBAAA;EAAkB,WAAA;EAAW,SAAA;EAAS,2BAAA;EAA2B,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAkB,mBDnZhH;AC2cvB;;AAvDA;EAAY,cAAA;EAAc,gBAAA;AA4D1B;;AA3DA;EAAe,iDAAA;EAAiD,sBAAA;EAAsB,2BAAA;AAiEtF;;AA/DA;EAAQ,aAAA;EAAa,uBAAA;EAAuB,SAAA;EAAS,mBAAA;EAAmB,qBAAA;EAAqB,cAAA;EAAc,6BAAA;EAAyB,gBAAA;AA0EpI;;AA1EoJ;EAAI,oBAAA;EAAoB,mBAAA;EAAmB,QAAA;AAgF/L;;AAhFuM;EAAM,UAAA;EAAU,WAAA;EAAW,2BAAA;EAA+B,kBAAA;EAAkB,mBAAA;AAwFnR;;AAxFsS;EAAW,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAkB,mBDvZjU;ACsfvB;;AA7FA;EAAe,kBAAA;EAAkB,aAAA;AAkGjC;;AAjGA;EAAgB,WAAA;EAAW,gBAAA;EAAgB,eAAA;EAAe,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,uCAAA;EAAoC,mBAAA;EAAmB,sCAAA;EAAsC,6BAAA;EAAyB,oBAAA;EAAoB,eAAA;EAAe,gBAAA;EAAgB,eAAA;AAkHjS;;AAjHA;EAAsC,uCAAA;EAAmC,+CAAA;AAsHzE;;AArHA;EAAyB,YAAA;EAAY,mBAAA;AA0HrC;;AAzHA;EAAa,kBAAA;EAAkB,qBAAA;EAAqB,OAAA;EAAO,QAAA;EAAQ,UAAA;EAAU,aAAA;EAAa,YAAA;EAAY,wCAAA;EAAoC,mBAAA;EAAmB,sCAAA;EAAsC,6CAAA;EAA0C,iBAAA;EAAiB,gBAAA;AAyI9P;;AAxIA;EAAqB,cAAA;AA4IrB;;AA3IA;EAAe,WAAA;EAAW,gBAAA;EAAgB,eAAA;EAAe,aAAA;EAAa,mBAAA;EAAmB,SAAA;EAAS,mBAAA;EAAmB,uBAAA;EAAuB,cAAA;EAAc,oBAAA;EAAoB,eAAA;EAAe,gBAAA;EAAgB,eAAA;AA2J7M;;AA1JA;EAA8C,qCAAA;EAAiC,cAAA;AA+J/E;;AA7JA;EACI,oBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAgKJ;;AA7JA;EACI,aAAA;EACA,aAAA;EACA,yBAAA;AAgKJ;AA9JI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAgKR;AA9JQ;EACI,0BAAA;AAgKZ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-surface: $color-surface;\n$bw-surface-2: $color-surface-soft;\n$bw-text: $text-main;\n$bw-muted: rgba($text-main, 0.68);\n$bw-border: $color-border;\n$bw-primary: $color-primary;\n$bw-radius-lg: $radius-xl;\n\n.booking {\n    width: 100%;\n    max-width: 370px;\n    background: $bw-surface;\n    border: 1px solid rgba(12, 36, 28, 0.075);\n    border-radius: 22px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, .03);\n    padding: 24px 18px 16px;\n    font-family: \"Sora\", sans-serif;\n    display: flex;\n    flex-direction: column;\n\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);\n    }\n\n    &__head {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n    }\n\n    &__title {\n        margin: 0 0 10px;\n        text-align: center;\n        font-size: 17px;\n        font-weight: 800;\n        line-height: 1.15;\n        letter-spacing: -0.025em;\n        color: $bw-text;\n    }\n\n    &__request-title {\n        white-space: nowrap;\n        letter-spacing: -0.035em;\n    }\n\n    &__request-intro {\n        max-width: 320px;\n        margin: 0 auto 14px;\n        text-align: center;\n        font-size: 12px;\n        line-height: 1.45;\n        color: #5A6A63;\n    }\n\n    &__legend {\n        display: flex;\n        gap: 16px;\n        align-items: center;\n        justify-content: center;\n        margin: 0 0 14px;\n        font-size: 10px;\n        color: #5f6d67;\n        font-weight: 700;\n    }\n\n    &__dot {\n        width: 12px;\n        height: 12px;\n        border-radius: 999px;\n        border: 2px solid $bw-primary;\n        display: inline-block;\n        margin-right: 6px;\n        vertical-align: -2px;\n        background: white;\n\n        &--selected {\n            background: $bw-primary;\n        }\n    }\n\n    &__today-mark {\n        display: inline-block;\n        margin-right: 4px;\n        color: #D6A640;\n        font-weight: 900;\n        font-size: 11px;\n        vertical-align: middle;\n        line-height: 1;\n        background: transparent;\n        box-shadow: none;\n    }\n\n    &__calendar-card {\n        padding: 6px 2px 10px;\n    }\n\n    &__calendar-days-frame {\n        padding: 8px 6px 7px;\n        border: 1px solid rgba(12, 36, 28, 0.075);\n        border-radius: 16px;\n    }\n\n    &__field-wrapper {\n        margin-top: 10px;\n    }\n\n    &__field-inner {\n        width: 100%;\n    }\n\n    &__select-container {\n        background: $bw-surface-2;\n        border: 1px solid rgba(12, 36, 28, 0.08);\n        border-radius: 18px;\n        box-shadow: 0 8px 22px rgba(0, 0, 0, .02);\n        display: flex;\n        align-items: center;\n        padding-right: 14px;\n        transition: border-color 0.2s;\n\n        &:hover {\n            border-color: rgba($bw-primary, 0.5);\n        }\n\n        :global(.MuiTextField-root) {\n            .MuiOutlinedInput-notchedOutline {\n                border: none;\n            }\n\n            .MuiInputBase-root {\n                height: 48px;\n            }\n\n            .MuiSelect-select {\n                padding-left: 14px;\n                font-size: 13px;\n                font-weight: 700;\n                color: $bw-text;\n            }\n        }\n    }\n\n    &__field-icon {\n        width: 20px;\n        height: 20px;\n        stroke: #6f7d75;\n        stroke-width: 1.9px;\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        margin-right: 8px;\n    }\n\n\n\n    &__type-picker {\n        margin: 0 0 12px;\n    }\n\n    &__mini-label {\n        font-size: 10px;\n        font-weight: 800;\n        letter-spacing: 0.11em;\n        text-transform: uppercase;\n        color: #6E897C;\n    }\n\n    &__secondary-group {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        gap: 12px;\n        margin-top: 8px;\n    }\n\n    &__secondary {\n        min-height: 40px;\n        padding: 0 11px;\n        border: 1px solid rgba(130, 177, 148, 0.58);\n        border-radius: 15px;\n        background: transparent;\n        color: #32453B;\n        font-family: inherit;\n        font-size: 11px;\n        font-weight: 800;\n        cursor: pointer;\n        transition: background-color 0.2s, border-color 0.2s;\n\n        &:hover {\n            background: rgba(130, 177, 148, 0.08);\n        }\n\n        &--active {\n            background: rgba(130, 177, 148, 0.16);\n            border-color: $bw-primary;\n        }\n    }\n\n    &__type-helper {\n        margin: 8px 2px 0;\n        font-size: 11px;\n        line-height: 1.5;\n        color: #5A6A63;\n    }\n\n    &__split-card {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        gap: 8px;\n        margin-top: 10px;\n        background: transparent;\n        border: 0;\n        border-radius: 0;\n        overflow: visible;\n\n        button {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 8px;\n            min-height: 40px;\n            padding: 0 11px;\n            border: 1px solid rgba(130, 177, 148, 0.58);\n            border-radius: 15px;\n            background: transparent;\n            color: #32453B;\n            font-size: 11px;\n            line-height: 1.25;\n            font-weight: 800;\n            font-family: inherit;\n            cursor: pointer;\n            transition: background .16s ease, border-color .16s ease, color .16s ease;\n\n            img {\n                width: 21px;\n                height: 21px;\n                object-fit: contain;\n                opacity: .88;\n                flex: 0 0 auto;\n            }\n\n            &.is-active {\n                background: rgba(130, 177, 148, .16);\n                border-color: $bw-primary;\n                color: #32453B;\n                box-shadow: none;\n            }\n\n            &:hover:not(.is-active) {\n                background: rgba(130, 177, 148, .12);\n            }\n        }\n    }\n\n    &__price-row {\n        min-height: 46px;\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) auto;\n        align-items: center;\n        gap: 12px;\n        margin-top: 10px;\n        padding: 6px 2px 5px 10px;\n    }\n\n    &__price-copy {\n        display: flex;\n        align-items: baseline;\n        gap: 9px;\n        min-width: 0;\n    }\n\n    &__price-summary {\n        font-size: 12px;\n        white-space: nowrap;\n    }\n\n    &__price-duration {\n        font-size: 10.5px;\n        font-weight: 700;\n        color: $bw-muted;\n        white-space: nowrap;\n    }\n\n    &__price {\n        display: flex;\n        align-items: baseline;\n        white-space: nowrap;\n    }\n\n    &__price-amount {\n        font-size: 23px;\n        font-weight: 800;\n        letter-spacing: -0.025em;\n        line-height: 1;\n    }\n\n    &__cta {\n        margin-top: 10px;\n        width: 100%;\n        min-height: 46px;\n        border-radius: 15px;\n        border: 0;\n        background: $bw-primary;\n        color: white;\n        font-family: inherit;\n        font-size: 14px;\n        font-weight: 800;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover:not(:disabled) {\n            background: darken($bw-primary, 5%);\n            transform: translateY(-1px);\n        }\n\n        &:disabled {\n            cursor: not-allowed;\n            opacity: 0.6;\n        }\n    }\n\n    &__secondary-cta {\n        width: 100%;\n        margin-top: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        min-height: 46px;\n        padding: 0 16px;\n        border: 1px solid rgba(130, 177, 148, .58);\n        border-radius: 15px;\n        background: transparent;\n        color: #32453B;\n        font-family: inherit;\n        font-size: 14px;\n        font-weight: 800;\n        cursor: pointer;\n        transition: background .18s ease;\n\n        svg {\n            width: 16px;\n            height: 16px;\n            fill: none;\n            stroke: currentColor;\n            stroke-width: 1.8;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n        }\n\n        &:hover {\n            background: rgba(130, 177, 148, .10);\n        }\n    }\n\n    &__validation-summary {\n        margin: 14px 0 0;\n        padding: 9px 10px;\n        border: 1px solid rgba(173, 77, 67, .24);\n        border-radius: 12px;\n        background: #FAEEEB;\n        color: #82483F;\n        font-size: 10px;\n        font-weight: 700;\n        line-height: 1.45;\n    }\n\n\n}\n\n@keyframes shake {\n\n    0%,\n    100% {\n        transform: translateX(0);\n    }\n\n    25% {\n        transform: translateX(-5px);\n    }\n\n    50% {\n        transform: translateX(5px);\n    }\n\n    75% {\n        transform: translateX(-5px);\n    }\n}\n\n.shake {\n    animation: shake 0.4s cubic-bezier(.36, .07, .19, .97) both;\n}\n.calendar{width:100%;padding:2px 3px 3px}\n.calendar-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;min-height:30px}\n.month{margin-left:10px;font-size:12px;font-weight:800;text-transform: capitalize;}\n.navs{display:flex}\n.nav-btn{width:30px;height:30px;border:0;border-radius:50%;background:transparent;color:#42524B;font:inherit;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;}\n.nav-btn:hover{background:rgba(0,0,0,0.05);}\n.calendar-frame{padding:7px 6px 6px;border:1px solid rgba(12,36,28,.07);border-radius:16px}\n.dow,.days{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));text-align:center}\n.dow{padding-bottom:5px;margin-bottom:6px;border-bottom:1px solid rgba(12,36,28,.06)}\n.dow span{font-size:8px;font-weight:800}\n.days{row-gap:2px}\n.slot{height:28px;display:grid;place-items:center}\n.day{position:relative;width:30px;height:30px;border:0;border-radius:50%;background:transparent;color:#5B6862;font:inherit;font-size:11px;font-weight:600;display:flex;align-items:center;justify-content:center;padding:0;}\n.day--out{color:#B0B7B3}\n.day--available{box-shadow:inset 0 0 0 1.3px $bw-primary;background:#EEF5F0;color:#32483E;cursor:pointer;}\n.day--requestable{color:#4C5D55;cursor:pointer;}\n.day--booked::after{content:\"\";position:absolute;bottom:3px;left:50%;transform:translateX(-50%);width:5px;height:5px;border-radius:50%;background:$bw-primary}\n.day--today{color:#D6A640;font-weight:900}\n.day--selected{background:var(--bw-primary, #82B194) !important;color:#fff !important;font-weight:900 !important}\n\n.legend{display:flex;justify-content:center;gap:14px;align-items:center;margin:-4px 2px 10px;font-size:9px;color:rgba(19,35,29,.66);font-weight:700}.lg{display:inline-flex;align-items:center;gap:4px}.ring{width:9px;height:9px;border:1.3px solid $bw-primary;border-radius:50%;background:#EEF5F0}.dot-green{width:8px;height:8px;border-radius:50%;background:$bw-primary}\n\n.period-picker{position:relative;margin-top:0}\n.period-trigger{width:100%;min-height:42px;padding:0 13px;display:flex;align-items:center;justify-content:space-between;border:1px solid rgba(12,36,28,.10);border-radius:16px;background:var(--bw-surface, #F7F5F1);color:rgba(19,35,29,.72);font-family:inherit;font-size:11px;font-weight:650;cursor:pointer}\n.period-trigger[aria-expanded=\"true\"]{border-color:rgba(130,177,148,.72);box-shadow:0 0 0 3px rgba(130,177,148,.14)}\n.period-trigger:disabled{opacity:0.6;cursor:not-allowed}\n.period-menu{position:absolute;top:calc(100% + 6px);left:0;right:0;z-index:6;display:none;padding:6px;border:1px solid rgba(12,36,28,.08);border-radius:16px;background:var(--bw-surface, #F7F5F1);box-shadow:0 14px 28px rgba(19,35,29,.10);max-height:200px;overflow-y:auto}\n.period-menu.is-open{display:block}\n.period-option{width:100%;min-height:40px;padding:0 12px;display:flex;align-items:center;border:0;border-radius:11px;background:transparent;color:#13231D;font-family:inherit;font-size:12px;font-weight:750;cursor:pointer}\n.period-option.is-active,.period-option:hover{background:rgba(130,177,148,.16);color:#345443}\n\n.passive-compact-note {\n    margin: 18px 2px 8px;\n    color: rgba(19, 35, 29, 0.56);\n    font-size: 10.5px;\n    line-height: 1.5;\n    text-align: center;\n}\n\n.availability-dev-code-link {\n    margin: 0 2px;\n    display: flex;\n    justify-content: flex-end;\n    \n    a {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        color: #5E806C;\n        font-size: 10.5px;\n        font-weight: 800;\n        text-decoration: none;\n        \n        &:hover {\n            text-decoration: underline;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"booking": `BookingPanel_booking__ssfyt`,
	"booking__head": `BookingPanel_booking__head__H4HO8`,
	"booking__title": `BookingPanel_booking__title__K6ruR`,
	"booking__request-title": `BookingPanel_booking__request-title__BpJg5`,
	"booking__request-intro": `BookingPanel_booking__request-intro__jc8iu`,
	"booking__legend": `BookingPanel_booking__legend__QGZul`,
	"booking__dot": `BookingPanel_booking__dot__WLeTk`,
	"booking__dot--selected": `BookingPanel_booking__dot--selected__4v9BJ`,
	"booking__today-mark": `BookingPanel_booking__today-mark__1Avbe`,
	"booking__calendar-card": `BookingPanel_booking__calendar-card__kJJyZ`,
	"booking__calendar-days-frame": `BookingPanel_booking__calendar-days-frame__VYP1T`,
	"booking__field-wrapper": `BookingPanel_booking__field-wrapper__JKgBr`,
	"booking__field-inner": `BookingPanel_booking__field-inner__X42e-`,
	"booking__select-container": `BookingPanel_booking__select-container__U44VT`,
	"MuiOutlinedInput-notchedOutline": `BookingPanel_MuiOutlinedInput-notchedOutline__FRhsC`,
	"MuiInputBase-root": `BookingPanel_MuiInputBase-root__EclzM`,
	"MuiSelect-select": `BookingPanel_MuiSelect-select__BCOS5`,
	"booking__field-icon": `BookingPanel_booking__field-icon__DmP8F`,
	"booking__type-picker": `BookingPanel_booking__type-picker__zBrNt`,
	"booking__mini-label": `BookingPanel_booking__mini-label__h9BZM`,
	"booking__secondary-group": `BookingPanel_booking__secondary-group__sZ1GC`,
	"booking__secondary": `BookingPanel_booking__secondary__lYNKQ`,
	"booking__secondary--active": `BookingPanel_booking__secondary--active__jLVSV`,
	"booking__type-helper": `BookingPanel_booking__type-helper__4CC0n`,
	"booking__split-card": `BookingPanel_booking__split-card__IH+77`,
	"is-active": `BookingPanel_is-active__n2PCn`,
	"booking__price-row": `BookingPanel_booking__price-row__DCR7a`,
	"booking__price-copy": `BookingPanel_booking__price-copy__pJY21`,
	"booking__price-summary": `BookingPanel_booking__price-summary__Gd3u2`,
	"booking__price-duration": `BookingPanel_booking__price-duration__3i3WL`,
	"booking__price": `BookingPanel_booking__price__UEDao`,
	"booking__price-amount": `BookingPanel_booking__price-amount__0iV1d`,
	"booking__cta": `BookingPanel_booking__cta__Z3BIy`,
	"booking__secondary-cta": `BookingPanel_booking__secondary-cta__-ib-n`,
	"booking__validation-summary": `BookingPanel_booking__validation-summary__UUeUm`,
	"shake": `BookingPanel_shake__fAhsu`,
	"calendar": `BookingPanel_calendar__jNEUM`,
	"calendar-top": `BookingPanel_calendar-top__FHYxC`,
	"month": `BookingPanel_month__ws0VY`,
	"navs": `BookingPanel_navs__3DBuV`,
	"nav-btn": `BookingPanel_nav-btn__Xv8IT`,
	"calendar-frame": `BookingPanel_calendar-frame__T0tb-`,
	"dow": `BookingPanel_dow__F-ggq`,
	"days": `BookingPanel_days__Z6nCZ`,
	"slot": `BookingPanel_slot__jwwND`,
	"day": `BookingPanel_day__2ADRM`,
	"day--out": `BookingPanel_day--out__45rKU`,
	"day--available": `BookingPanel_day--available__dcoLs`,
	"day--requestable": `BookingPanel_day--requestable__J0kml`,
	"day--booked": `BookingPanel_day--booked__P1LFM`,
	"day--today": `BookingPanel_day--today__fCAEC`,
	"day--selected": `BookingPanel_day--selected__IhC+c`,
	"legend": `BookingPanel_legend__BtxQE`,
	"lg": `BookingPanel_lg__eh3ax`,
	"ring": `BookingPanel_ring__wGi4J`,
	"dot-green": `BookingPanel_dot-green__ViCDd`,
	"period-picker": `BookingPanel_period-picker__5qq4P`,
	"period-trigger": `BookingPanel_period-trigger__irnTO`,
	"period-menu": `BookingPanel_period-menu__pbut8`,
	"is-open": `BookingPanel_is-open__HGtxg`,
	"period-option": `BookingPanel_period-option__qPxl8`,
	"passive-compact-note": `BookingPanel_passive-compact-note__GpgO1`,
	"availability-dev-code-link": `BookingPanel_availability-dev-code-link__02Ka2`
};
export default ___CSS_LOADER_EXPORT___;
